import React from "react";
import { Star } from "lucide-react";

export default function Stars({ value = 0, size = 14, showCount = false, count = 0, className = "" }) {
  const stars = [1, 2, 3, 4, 5];
  return (
    <div className={`inline-flex items-center gap-1 ${className}`}>
      <div className="flex">
        {stars.map((n) => {
          const filled = value >= n - 0.25;
          const half = !filled && value >= n - 0.75;
          return (
            <span key={n} className="relative">
              <Star size={size} className="text-[#E2E8E5]" />
              {(filled || half) && (
                <span className="absolute inset-0 overflow-hidden" style={{ width: half ? "50%" : "100%" }}>
                  <Star size={size} className="text-[#F5B841] fill-[#F5B841]" />
                </span>
              )}
            </span>
          );
        })}
      </div>
      {showCount && (
        <span className="text-xs text-[#6E877C]">
          {value ? value.toFixed(1) : "New"}
          {count > 0 && ` · ${count}`}
        </span>
      )}
    </div>
  );
}
